<div class="container page-top mb-5">
  <h1 class="my-5">My Shopping Cart</h1>
  <p class="mb-5">Before finalizing your purchase, please review our <a
    href="https://software.utah.edu/return-policy.php" target="_blank">Return Policy.</a></p>

  <div class="row">
    <div class="col-12 col-lg-8">
      <div *ngFor="let lineItem of lineItems; index as i">
        <app-cart-item [lineItem]="lineItem"
                       [cart]="cart"
                       [editable]="true"
                       (processingStatusChanged)="cartItemProcessingCallback($event)"
                       (itemUpdated)="itemUpdated(i, lineItem, $event)"></app-cart-item>
      </div>
      <h3 *ngIf="!hasItems"><em>Your cart is empty.</em></h3>
    </div>

    <div class="col-12 col-lg-4" *ngIf="(cartChanges$ | async) as changes">
      <app-total *ngIf="cart" [cart]="cart"></app-total>
      <app-select-payment-method *ngIf="user?.employee && requiresDepartmentId"
                                 (paymentMethodEvent)="setPurchaseOrder($event)"></app-select-payment-method>
      <app-department-id *ngIf="requiresDepartmentId" [deptId]="changes.deptId"
                         (deptIdEvent)="updateDeptId($event.valid, $event.value)"></app-department-id>
      <app-comments *ngIf="requiresDepartmentId" [comments]="changes.comments"
                    (commentsEvent)="updateComments($event)"></app-comments>
      <button (click)="checkout(cart)" [disabled]="processing || (requiresDepartmentId && !changes.valid)"
              class="btn btn-primary py-3 my-1 col-12">Checkout
      </button>
      <app-make-payment [uccpConfig]="uccpConfig" [cart]="cart" [submitPayment]="submitPayment"></app-make-payment>
      <br>
      <button [routerLink]="''" class="btn btn-dark py-3 my-1 col-12">Continue Shopping</button>
    </div>
  </div>
</div>
